module.exports = [
  { title: 'twitter', icon: 'twitter-icon', link: 'https://twitter.com/vividhC' }
];


// WEBPACK FOOTER //
// ./src/utils/social-guns.js